export default __webpack_public_path__ + "static/media/babayagatower.7d23994a.jpg";